import React from 'react';
import { Chip, Stack } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { DAY_LABELS, formatTimeRange, formatDateRange } from './couponDisplay';

/**
 * Weekday "week strip": all 7 days, the active ones filled (primary), the rest
 * muted/outlined. A null/0 mask means the coupon has no day restriction.
 */
export const ValidDaysPills = ({ mask }: { mask?: number | null }) => {
  if (!mask) {
    return <Chip size="small" variant="outlined" label="Every day" />;
  }

  return (
    <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
      {DAY_LABELS.map((day, bit) => {
        const active = (mask & (1 << bit)) !== 0;
        return (
          <Chip
            key={day}
            size="small"
            label={day}
            color={active ? 'primary' : 'default'}
            variant={active ? 'filled' : 'outlined'}
            sx={{ opacity: active ? 1 : 0.55 }}
          />
        );
      })}
    </Stack>
  );
};

/** Outlined pill with a clock icon, e.g. "08:00 – 12:00" / "Any time". */
export const ValidTimePill = ({
  start,
  end,
}: {
  start?: number | null;
  end?: number | null;
}) => (
  <Chip
    size="small"
    variant="outlined"
    icon={<AccessTimeIcon />}
    label={formatTimeRange(start, end)}
  />
);

/** Outlined pill with a calendar icon, e.g. "Jul 1 – Jul 31, 2026" / "No date limit". */
export const ValidDatesPill = ({
  from,
  until,
}: {
  from?: string | null;
  until?: string | null;
}) => (
  <Chip
    size="small"
    variant="outlined"
    icon={<CalendarMonthIcon />}
    label={formatDateRange(from, until)}
  />
);
